import { useState, useEffect } from 'react';
import { _ProductVariant } from '../../../core/services/dataBean/EntityCatalogVdos';
import useDataBean from '../../../core/services/dataBean/useDataBean';



interface Props {
    idManufacturingStardard: number;
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectProductVariantByManufacturing = ({ idSelector, idManufacturingStardard, onChange, label }: Props) => {

    const Configurar = useDataBean(_ProductVariant)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector)
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [idManufacturingStardard])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {

        Configurar.instance.getProductVariantCatalogByManufacturingStandard(idManufacturingStardard).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }


    return (
        <>
            <label>{label ?? "Variantes/Tallas de Producto"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>

                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDProductVariant} >{item.DataBeanProperties.Reference}-{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}